<template>
  <div>
    <v-data-table
      v-model="selected"
      :items="data"
      :headers="headers"
      :loading="loading || internalLoading > 0"
      :search="search"
      :hide-default-footer="true"
			:items-per-page="-1"
      item-key="asset_id"
      show-select
      class="elevation-1 admin-table"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.notes="{ item }">
        <v-layout justify-center>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
              >
                mdi-file
              </v-icon>
            </template>
            <div class="asset-notes">
              <h6 class="notes-title">Notes: {{ item.vehicle_name }}</h6>
              <div v-if="item.notes != ''" class="notes-body">
                {{ item.notes }}
              </div>
              <div v-else class="notes-body">
                N/A
              </div>
            </div>
          </v-tooltip>
        </v-layout>
      </template>

      <template v-slot:item.last_seen="{ item }">
        {{ formatDate(readValueFromPresenceMap(item, 'last_seen')) }}
      </template>

      <template v-slot:item.location="{ item }">
        {{ readValueFromPresenceMap(item, 'location') }}
      </template>

      <template v-slot:item.battery_level="{ item }">
        {{ readValueFromPresenceMap(item, 'battery_level') }}
      </template>

      <template v-slot:item.actions="{item}">
        <div class="reports-action-launch" @click="launchRowAction">
          <v-icon>mdi-dots-vertical</v-icon>
          <ActionContainer :ref="item.key" :heading="'Action'" class="report-action-options">
            <!-- <ActionItem 
              label="Edit asset"
              icon="mdi-pencil"
              @click.native="showDialogAddCurrent(item, 'edit')"
            />
            
            <ActionItem
              :disabled="!$can('viewDeviceInfo')"
              label="Device Information"
              icon="mdi-chip"
              @click.native="showDialogAddCurrent(item, 'device_info')"
            />

            <ActionItem
              label="Move to Org"
              icon="mdi-arrow-right"
              @click.native="showDialogAddCurrent(item, 'move')"
            /> -->
            <ActionItem
              
              label="Show Location"
              :disabled="!$can('viewAsset')"
              icon="mdi-map-marker"
              @click.native="showDialogAddCurrent(item, 'location')"
            />
            <ActionItem
              
              label="Device Config"
              :disabled="!$can('updateAsset')"
              icon="mdi-settings"
              @click.native="showDialogAddCurrent(item, 'config')"
            />
            <ActionItem
              
              label="Unassign Device"
              :disabled="!$can('batchUnassignAssetsFromDevices')"
              icon="mdi-arrow-right"
              @click.native="showDialogAddCurrent(item, 'unassign')"
            />
          </ActionContainer>
        </div>
      </template>
    </v-data-table>

    <Pagination
      :pagination-info="paginationInfo"
      :show-row-option="true"
      @updatedPage="updatedPage"
    />
  </div>
</template>

<script>

import ActionContainer from '@/components/general/ActionContainer.vue';
import ActionItem from '@/components/general/ActionItem.vue';
import Pagination from "@/components/general/Pagination.vue"

import moment from "moment";

import { Logger } from "aws-amplify"
const logger = new Logger("assigned assets table")

export default {
  name: 'AssignedAssetsTable',

  components: {
    ActionContainer,
    ActionItem,
    Pagination
  },

  props: {
    data: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    presence: {
      type: Object,
      required: true
    },
    paginationInfo: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'asset_name',
          align: 'left'
        },
        {
          text: 'IMEI',
          value: 'imei',
          align: 'left'
        },
        {
          text: 'Serial',
          value: 'serial_number',
          align: 'left'
        },
        {
          text: 'Make',
          value: 'asset_make',
          align: 'left'
        },
        {
          text: 'Model',
          value: 'asset_model',
          align: 'left'
        },
        {
          text: 'Firmware',
          value: 'firmware_version',
          align: 'left'
        },
        {
          text: 'ICCID',
          value: 'iccid',
          align: 'left'
        },
        {
          text: 'Last Seen',
          value: 'last_seen',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'left'
        }
      ],
      selected: [],
      internalLoading: 0,
      tableData: []
    }
  },

  watch: {
    selected(val) {
      this.$emit('selectionUpdatedAssets', val);
    },

    loading(val) {
      if(val) {
        this.selected = []
      }
    }
  },

  methods: {
    updatedPage(page, rows) {
      logger.info('assigned assets table updatedPage', page, rows)
      this.$emit('updatedPage', page, rows)
    },

    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },

    showDialogAddCurrent(item, type) {
      logger.info(item, type)
      let selectedAmount = this.selected.length;

      if (item) {
        if(!this.selected.includes(item)) {
          this.selected.push(item);
        }
      } else {
        // Clear selection for single select

        if (selectedAmount === 1) {
          this.selected = [];
        }
      }

      if(type == 'edit') {
        this.$emit('toggleEditAsset')
      }

      if(type == 'device_info') {
        this.$emit('toggleDeviceInfo')
      }

      if(type == 'move') {
        this.$emit('toggleMoveAsset')
      }
      if(type == 'unassign') {
        this.$emit('unassignAssetDevice')
      }
      if(type == 'location') {
        this.$emit('showLocation')
      }
      if(type == 'config') {
        this.$emit('showAssetConfig')
      }
    },

    readValueFromPresenceMap(item, val) {
      if(!item || !val) return ''

      if(!Object.hasOwn(this.presence, item.asset_id)) return ''
   
      return this.presence[item.asset_id][val]
    },

    formatDate(val) {
      if(!val) return ''
      return moment(val).format('DD MMM YYYY HH:mm:ss')
    }
  }
}

</script>